import i18n from "i18next"
import backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    languages: ["en", "nl", "pa"],
    ns: ["translation"],
    defaultNS: "translation",
    debug: false,
    keySeparator: ">",
    nsSeparator: "|",
    interpolation: {
      escapeValue: false
    },
    backend: {
      // De datum achter het vraagteken is de cache-buster. De browser bewaart een vertaalbestand
      // per URL, dus zolang deze niet verandert blijft hij de oude tekst tonen, ook na een deploy.
      // Ophogen zodra er teksten wijzigen; dat is nu de reden dat je oude labels kunt blijven zien.
      loadPath: "/locales/{{lng}}/{{ns}}.json?20261026"
    }
  })

export default i18n